<div fxLayout="column" fxLayoutAlign="start center" class="layout-wrapper">
  <div fxFlex="100%" fxFlex.lt-md="100%" class="flex-wrapper" style="border: 2px dashed red">
    <ng-content></ng-content>
  </div>
</div>
